// components/create/EmojiSetSelector.js
import React from 'react';
import '../../styles/EmojiSetSelector.scss';
import Icon from '../Icon';
import Portal from '../Portal';

const EMOJI_SETS = {
  basic: { going: '✅', maybe: '🤔', notGoing: '❌' },
  thumbs: { going: '👍', maybe: '🤷', notGoing: '👎' },
  faces: { going: '😊', maybe: '😐', notGoing: '😔' },
  party: { going: '🎉', maybe: '🎊', notGoing: '😢' },
};

export default function EmojiSetSelector({ visible, onClose, selectedSet, onSelect }) {
  if (!visible) return null;

  return (
    <Portal>
    <div className="modal-overlay" onClick={onClose}>
      <div className="emoji-selector-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <button className="close-button" onClick={onClose}>
            <Icon name="close" />
          </button>
          <h2 className="modal-title">RSVP Style</h2>
          <div className="header-spacer"></div>
        </div>

        {/* Content */}
        <div className="modal-content">
          {Object.entries(EMOJI_SETS).map(([key, emojis]) => (
            <div
              key={key}
              className={`emoji-option ${selectedSet === key ? 'selected' : ''}`}
              onClick={() => onSelect(key, emojis)}
            >
              <div className="option-content">
                <div className="emoji-preview">
                  <span className="emoji">{emojis.going}</span>
                  <span className="emoji">{emojis.maybe}</span>
                  <span className="emoji">{emojis.notGoing}</span>
                </div>
                <div className="option-text">
                  <h3 className="option-label">
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </h3>
                  <div className="emoji-labels">
                    <span className="label-item">
                      {emojis.going} Going
                    </span>
                    <span className="label-item">
                      {emojis.maybe} Maybe
                    </span>
                    <span className="label-item">
                      {emojis.notGoing} Not Going
                    </span>
                  </div>
                </div>
                {selectedSet === key && (
                  <div className="option-checkmark">
                    <Icon name="checkmark-circle" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </Portal>
  );
}